import React from "react";
import Header from "../../components/ui/Header";
import Footer from "../../components/ui/Footer";

const Biography = () => {
    return (
        <div className="text-gray-900 min-h-screen flex flex-col">
            {/* HEADER */}
            <Header/>

            {/* CONTENIDO PRINCIPAL */}
            <main className="flex-1 w-full py-24 px-6 md:px-16 flex flex-col lg:flex-row items-center justify-between gap-12">

                {/* Imagen – móvil arriba / desktop derecha */}
                <div className="w-full lg:w-1/2 flex justify-center order-1 lg:order-2">
                    <img
                        src="/assets/images/rosamariacifuentes.jpg"
                        alt="Rosa María Cifuentes Castañeda"
                        className="
                rounded-2xl
                shadow-xl
                object-cover
                w-[260px] h-[340px]
                sm:w-[300px] sm:h-[400px]
                lg:w-[400px] lg:h-[500px]
            "
                    />
                </div>

                {/* Texto – móvil abajo / desktop izquierda */}
                <div className="w-full lg:w-1/2 space-y-5 text-justify order-2 lg:order-1">

                    <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-800 leading-tight text-center lg:text-left">
                        Rosa María Cifuentes Castañeda
                    </h1>

                    <p className="text-base sm:text-lg leading-relaxed">
                        Magíster en Periodismo y coach ontológico. Ex catedrática en la
                        Universidad de San Martín de Porres y el Instituto San Ignacio de
                        Loyola. Ha sido asesora de comunicaciones en instituciones del Estado,
                        en los rubros de educación, salud y cultura.
                    </p>

                    <p className="text-base sm:text-lg leading-relaxed">
                        Dirige la empresa <strong>Resurge</strong>, que brinda asesorías de coaching empresarial
                        en Perú, Colombia, Chile, Bolivia, Uruguay, Guatemala, El Salvador,
                        España e Italia. Realiza terapias para el manejo de las emociones y el
                        autoconocimiento.
                    </p>

                    <p className="text-base sm:text-lg leading-relaxed">
                        Es especialista en <em>mian xiang</em>, morfopsicología, comunicación no verbal,
                        grafología y astrología en salud emocional. Además, se desempeña como
                        panelista en programas de televisión y radio.
                    </p>

                    <p className="text-base sm:text-lg leading-relaxed">
                        Fue jurado en <em>Psíquicos</em> (2013). Entre sus títulos publicados destacan
                        <em>
                            {" "}Presencias, Cómo aman ellos, Cómo aman ellas, Destellos de luna,
                            13 asesinas, La verdad oculta de los rostros al poder, Lesiones de amor,
                            La magia de tu nombre, Presencias II, Miénteme si puedes, La magia del amor,
                            Libre del miedo, La magia de tu casa, El mal acecha, ¡No más tóxicos!
                            y Decide ser feliz.
                        </em>
                    </p>

                    <p className="text-base sm:text-lg leading-relaxed">
                        Publicó también <em>Cuentos con valores</em> y las agendas Zéfiro
                        2019–2024.
                    </p>

                </div>
            </main>


            <Footer/>
        </div>
    );
};

export default Biography;
